import { AnalyticsDataType } from '@/shared/types/analytics';

import { store } from '@/shared/store';

window.dataLayer = window.dataLayer || [];
window.ym        = window.ym        || (() => {});

const push = (data: AnalyticsDataType) => {
    const { order: { order: { customerInfo } } } = store.getState();
    const id = Number(document.body.dataset.yandexMetrikaId);

    window.dataLayer.push({ event: 'ga4', ...data });
    window.ym(id, 'reachGoal', data.event_name, {
        'user_id': customerInfo.profileId,
        ...data,
    });
};

export const trackPaymentSubmit = () => {
    push({
        'event_name': 'go_to_purchase',
        application : 'shop',
        flow        : 'travel_pay',
        step        : 'payment',
    });
};

export const trackPaymentError = (error: {
    code: string
    content: string
}) => push({
    'event_name': 'event_error',
    application : 'shop',
    error       : 'go_to_purchase',
    flow        : 'travel_pay',
    step        : 'payment',
    'item_id'   : error.code,
    'item_name' : error.content,
    type        : 'service',
});
